import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import API_BASE_URL from '../../../../../Constants';

const StepListLookupModal = ({ open, onClose }) => {
  const [stepLists, setStepLists] = useState([]);

  // 1) Fetch step‐lists
  useEffect(() => {
    if (!open) return;

    const fetchStepLists = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/step-lists`, {
          credentials: 'include',
        });
        if (!res.ok) {
          throw new Error(`Failed to fetch step lists. Status: ${res.status}`);
        }
        const data = await res.json();
        setStepLists(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Error fetching step lists:', err);
        setStepLists([]);
      }
    };

    fetchStepLists();
  }, [open]);

  // 2) Handle “Select”
  const handleSelect = (list) => {
    onClose(list.stepListId, list.stepListDescription);
  };

  // 3) Handle “Cancel”
  const handleCancel = () => {
    onClose(null, null);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      // a) Hide the default backdrop so we can see the main modal behind it:
      hideBackdrop
      // b) Some apps also do "disablePortal" or "container={...}" 
      //    so it stays within the same DOM node, if needed.

      // c) Position the paper on the right side:
      PaperProps={{
        style: {
          position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
          width: '600px',      // your desired width
          zIndex: 3000,        // above the main modal’s 1500 or 2000
          maxHeight: 'calc(100vh - 80px)',  // so it fits in vertical space
          overflowY: 'auto',   // scroll if it’s too tall
        },
      }}

      // d) Also set the “style” of the overall Dialog container to manage zIndex or left offset
      style={{
        zIndex: 3000,
      }}

      // e) We disable “enforceFocus” so you can still interact with the main modal:
      disableEnforceFocus
      disableAutoFocus
    >
      {/* HEADER */}
      <div className="flex items-center justify-between p-4 border-b border-gray-300">
        <h2 className="text-xl font-bold">Step List Lookup</h2>
        <button onClick={handleCancel} className="p-1 text-gray-500 hover:text-gray-700">
          X
        </button>
      </div>

      <DialogContent dividers style={{ padding: '0px' }}>
        {/* We can wrap table in a scrollable container or use the parent's overflow */}
        <div style={{ maxHeight: 'calc(100vh - 160px)', overflowY: 'auto', padding: '1rem' }}>
          <p className="text-sm mb-2">Choose an existing Step List:</p>
          <table className="w-full border text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-2 border">List ID</th>
                <th className="p-2 border">Test ID</th>
                <th className="p-2 border">Description</th>
                <th className="p-2 border" />
              </tr>
            </thead>
            <tbody>
              {stepLists.map((lst) => (
                <tr key={lst.stepListId} className="border-b hover:bg-gray-50">
                  <td className="p-2 border text-center">{lst.stepListId}</td>
                  <td className="p-2 border">{lst.testId}</td>
                  <td className="p-2 border">{lst.stepListDescription || ''}</td>
                  <td className="p-2 border text-center">
                    <button
                      onClick={() => handleSelect(lst)}
                      className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Select
                    </button>
                  </td>
                </tr>
              ))}

              {/* If none found */}
              {stepLists.length === 0 && (
                <tr>
                  <td colSpan={4} className="p-2 text-center text-gray-500">
                    No step lists found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StepListLookupModal;
